/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use it`)
};

const es_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo usarlo`)
};

const de_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert’s`)
};

const nl_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe het werkt`)
};

const fr_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l’utiliser`)
};

const it_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si usa`)
};

const pt_br2_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const pt_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const ja_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い方`)
};

const zh_yt_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_howto_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_howto_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_howto_title", locale)
	if (locale === "en") return en_yt_howto_title(inputs)
	if (locale === "es") return es_yt_howto_title(inputs)
	if (locale === "de") return de_yt_howto_title(inputs)
	if (locale === "nl") return nl_yt_howto_title(inputs)
	if (locale === "fr") return fr_yt_howto_title(inputs)
	if (locale === "it") return it_yt_howto_title(inputs)
	if (locale === "pt-BR") return pt_br2_yt_howto_title(inputs)
	if (locale === "pt") return pt_yt_howto_title(inputs)
	if (locale === "ja") return ja_yt_howto_title(inputs)
	return zh_yt_howto_title(inputs)
};